"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBestPracticeIssue = void 0;
exports.filterIssuesByConfig = filterIssuesByConfig;
const accessibility_standards_1 = require("@deque/accessibility-standards");
const issue_mapper_1 = require("./issue-mapper");
const isBestPracticeIssue = (issue, config = { accessibilityStandard: 'wcag22aaa' }) => (0, accessibility_standards_1.getIssueType)((0, issue_mapper_1.getIssueTags)(issue), config) === 'best-practice';
exports.isBestPracticeIssue = isBestPracticeIssue;
function filterIssuesByConfig(issues, configFilters) {
    const matchesRuleset = ({ tags = [] }) => configFilters.configAccessibilityStandard === 'all' ||
        !!tags.filter(tag => 
        // @ts-expect-error - It's okay that the tag does not match, we're just trying to validate that the list of tags is one of the ones in the selected ruleset
        accessibility_standards_1.rulesets[configFilters.configAccessibilityStandard].tags.includes(tag)).length;
    const isBestPracticesEnabled = configFilters.configBestPractices === 'enabled';
    const isAdvancedRulesEnabled = configFilters.configAdvancedRules === 'enabled';
    const isNeedsReviewDisabled = configFilters.configNeedsReview === 'disabled';
    const accessibilityStandard = configFilters.configAccessibilityStandard;
    return issues.filter(issue => {
        const isIssueBestPractice = (0, exports.isBestPracticeIssue)(issue, {
            accessibilityStandard: accessibilityStandard || 'wcag22aaa'
        });
        return ((isBestPracticesEnabled || !isIssueBestPractice) &&
            (isAdvancedRulesEnabled || !issue.isAdvanced) &&
            (!isNeedsReviewDisabled || !issue.isNeedsReview) &&
            ((accessibilityStandard && !isIssueBestPractice
                ? matchesRuleset(issue)
                : true) ||
                (accessibilityStandard &&
                    accessibilityStandard === 'TTv5' &&
                    issue.isManual
                    ? true
                    : matchesRuleset(issue))));
    });
}
//# sourceMappingURL=filter-extension-issues.js.map